import type { Company, CompanyLocation } from '~/types';

export default (company: typeof Company | null = null, location: typeof CompanyLocation | null = null, customName: string = '') => {  
  let title = ``;

  if (company && location) {
    title = `${company.name} - ${location.name}`;
  } else if (!company && location) {
    title = `${location.name} in ${location.city}`;
  } else if (company && !location) {
    title = `${company.name}`;
  } else if (!company && !location) {
    title = ``;
  }

  if (customName) {
    title = customName;
  }

  let description = '';

  if (location) {
    description = `${location.name} in ${location.city}`;
    if (location.description) {
      description += ` - ${location.description}`;
    }
    if (location.services && location.services.length > 0) {
      const serviceNames = location.services.map(service => service.name).join(', ');
      description += ` Angebotene Dienstleistungen: ${serviceNames}.`;
    }
  }

  if (description.length > 160) {
    description = description.substring(0, 157) + '...';
  }

  return {
    title: `${title} - TerminTiger`,
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: description
      }
    ]
  }
}
